import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import rootReducer from './root-reducer'

const middleware = [thunk]

const tokenFromStorage = localStorage.getItem('japaToken') ? localStorage.getItem('japaToken') : null

const initialState = {
    userLogin: { token: tokenFromStorage }
}

const store = createStore(rootReducer, initialState, composeWithDevTools(applyMiddleware(...middleware)))

export default store;